export const API_ROOT = 'https://agritrade.tari.gov.tw/api/'



// WEBPACK FOOTER //
// ./src/api/config.js